import { render, staticRenderFns } from "./TransactionPerson.vue?vue&type=template&id=2b3a9c89&scoped=true&"
import script from "./TransactionPerson.vue?vue&type=script&lang=js&"
export * from "./TransactionPerson.vue?vue&type=script&lang=js&"
import style0 from "./TransactionPerson.vue?vue&type=style&index=0&id=2b3a9c89&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3a9c89",
  null
  
)

export default component.exports